export const vaccinationTaskTags = {
  TASK: 'task',
  TASKS_ARCHIVE: 'tasks_archive',
};
